import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {GetHealthDates, GetHealthDatesParams, GetHealthDatesModel} from 'domain/usecases';

export class RemoteGetHealthDates implements GetHealthDates {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetHealthDatesModel>,
	) {}

	async get({signal, ...params}: GetHealthDatesParams): Promise<GetHealthDatesModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
